import { isMobile } from 'react-device-detect';
import { ClientCategory, Roles, User } from '../types';

export const showToRoles = (
  roles: Array<Roles | ClientCategory> | 'admin' | 'adminRead' | 'client',
  user: User,
): boolean => {
  const myRole = user.type;
  const clientCategory = user.clientEmployee?.client?.category;

  if (!roles) return false;

  if (roles === 'admin')
    return [
      'SUPER_ADMIN',
      'YARD_COMPANY_ADMIN',
      'YARD_COMPANY_EMPLOYEE',
      'YARD_MANAGER',
      'YARD_DISPATCHER',
    ].some((role) => myRole === role);

  if (roles === 'adminRead')
    return [
      'SUPER_ADMIN',
      'YARD_COMPANY_ADMIN',
      'YARD_COMPANY_EMPLOYEE',
      'YARD_COMPANY_VIEWER',
      'YARD_MANAGER',
      'YARD_DISPATCHER',
    ].some((role) => myRole === role);

  if (roles === 'client')
    return ['CLIENT_MANAGER', 'CLIENT_DISPATCHER'].some((role) => myRole === role);

  return roles.some((role) => myRole === role || clientCategory === role);
};

export const showToRolesMobile = (
  roles: Array<Roles | ClientCategory> | 'admin' | 'adminRead' | 'client',
  user: User,
  isMobileScreen?: boolean,
): boolean => {
  if (!showToRoles(roles, user)) return false;
  if (!isMobile && !isMobileScreen) return false;

  return true;
};
